import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import locale from 'element-plus/lib/locale/lang/zh-cn';

import App from './App.vue';
import router from './router';
import store from './store';
import $filters from './core/plugins/filter';

import componentsInstall from '@/core/plugins/components-install';
import './core/plugins/permission';
import 'element-plus/dist/index.css';

const app = createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, {
    size: 'default',
    locale,
  })
  .use($filters);

componentsInstall(app);

app.mount('#app');
